import { Link } from 'react-router-dom';
import { formatCurrency } from '../../lib/currency';

const STATUS_LABELS = {
  PENDING_PAYMENT: 'Wacht op betaling', confirmed: 'Bevestigd', processing: 'In verwerking',
  shipped: 'Verzonden', delivered: 'Geleverd', cancelled: 'Geannuleerd', refunded: 'Terugbetaald',
};
const STATUS_COLORS = {
  PENDING_PAYMENT: 'bg-yellow-100 text-yellow-800', confirmed: 'bg-blue-100 text-blue-800',
  processing: 'bg-blue-100 text-blue-800', shipped: 'bg-purple-100 text-purple-800',
  delivered: 'bg-green-100 text-green-800', cancelled: 'bg-red-100 text-red-800',
  refunded: 'bg-gray-100 text-gray-700',
};

export default function OrdersSection({ orders }) {
  return (
    <section>
      <h2 className="font-serif text-2xl font-light mb-6 text-foreground">Mijn bestellingen</h2>
      {orders.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-border rounded-2xl">
          <p className="font-serif text-xl text-muted-foreground mb-2">Nog geen bestellingen</p>
          <Link to="/catalog" className="text-sm text-primary font-medium hover:underline">Ontdek onze producten</Link>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
          <div className="hidden md:grid grid-cols-4 gap-4 px-5 py-3.5 bg-muted/50 text-xs font-semibold text-muted-foreground uppercase tracking-wider border-b border-border">
            <span>Bestelnummer</span><span>Datum</span><span>Status</span><span className="text-right">Totaal</span>
          </div>
          {orders.map((order, i) => (
            <Link key={order._id} to={`/account/orders/${order.orderNumber}`} data-testid={`order-link-${order.orderNumber}`}
              className={`grid grid-cols-2 md:grid-cols-4 gap-4 px-5 py-4 ${i < orders.length - 1 ? 'border-b border-border' : ''} hover:bg-muted/20 transition-colors cursor-pointer`}>
              <span className="font-mono text-sm font-medium text-foreground">#{order.orderNumber || order._id.slice(-8).toUpperCase()}</span>
              <span className="text-sm text-muted-foreground">{new Date(order.created_at).toLocaleDateString('nl-BE', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
              <span><span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[order.status] || 'bg-muted text-muted-foreground'}`}>{STATUS_LABELS[order.status] || order.status}</span></span>
              <span className="text-sm font-semibold md:text-right text-foreground">{formatCurrency(order.totalAmount, 'nl')}</span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
